import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import DatePicker from "react-datepicker";
import SearchCB from "../../Assets/Images/CreateRole/Search.png";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format"; // Add this line
import DropDownCB from "./DropdownCB";
import { FULL_API_BASE_URL } from "../../Config/Config";
import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
import InterogativeImg from "../../Assets/Images/CommanImages/Informative.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import SelectedValue from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import "./CreateBatch.css";

const CreateBatch = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  SuccessImg,
}) => {
  const navigate = useNavigate();
  const [sliderValue, setSliderValue] = useState([65, 70]);
  const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedButton, setSelectedButton] = useState(25);
  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
  const [studentTypeId, setStudentTypeId] = useState(2);
  const [activeToggle, setActiveToggle] = useState(null);
  const [toggleKey, setToggleKey] = useState(0);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [courseOpted, setCourseOpted] = useState("");
  const [coachingMode, setCoachingMode] = useState("");
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedClassObj, setSelectedClassObj] = useState(null);
  const [initialData, setInitialData] = useState([]);
  const [firstTableData, setFirstTableData] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [excludeAssigned, setExcludeAssigned] = useState(false);
  const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
  const clientBranchId = dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient?.client_schema_name[6][0].client_id;
  const [batchDescription, setBatchDescription] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [firstSearchTerm, setFirstSearchTerm] = useState("");
  const [secondSearchTerm, setSecondSearchTerm] = useState("");
  const [isOpenBasicInfo, setIsOpenBasicInfo] = useState(true);
  const [isOpenAssignStudent, setIsOpenAssignStudent] = useState(true);
  const [selectedMentor, setSelectedMentor] = useState("N/A");
  const [sessionData, setSessionData] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const coachingModeOptions = [
    { id: "Online", label: "Online" },
    { id: "Classroom", label: "Classroom" },
    { id: "Hybrid", label: "Hybrid" },
  ];
  const classTypeAbbreviations = {
    Online: "OL",
    Classroom: "CL",
    Hybrid: "H",
  };
  const classTypeToId = {
    Online: 1,
    Classroom: 2,
    Hybrid: 3,
  };

  const handleStyle = {
    borderRadius: 0,
    backgroundColor: "#EFEFEF",
    border: "2px solid #999999",
    height: "28px",
    width: "20px",
    opacity: 1,
  };

  const trackStyle = {
    backgroundColor: "#D6D6D6",
    height: "20px",
    border: "1px solid #999999",
  };

  const railStyle = {
    borderRadius: 0, // Add this line
    backgroundColor: "#FFFFFF",
    height: "20px",
    border: "2px solid #999999",
  };

  const handleToggleChange = (type, val, typeId) => {
    if (val === 1) {
      setActiveToggle(type);
      setStudentTypeId(typeId);
      setToggleKey((prev) => prev + 1); // resets the other two toggles
    } else {
      setActiveToggle(null);
      setStudentTypeId(null);
    }
  };

  const toggleBasicInfoAccordion = () => setIsOpenBasicInfo((prev) => !prev);
  const toggleAssignStudentAccordion = () =>
    setIsOpenAssignStudent((prev) => !prev);

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-classes/`);
      const data = await response.json();
      setSelectedClass(data); // Save the entire class object in the state
    };

    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedCourseId && selectedClassObj && studentTypeId) {
      const fetchStudentData = async () => {
        const response = await fetch(
          `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}&session_id=${selectedSessionId}`
        );
        let data = await response.json();

        // Add this log to see actual API response shape
        console.log("Student API response:", data);

        // Ensure it's an array before mapping
        if (!Array.isArray(data)) {
          data = data?.data || data?.students || data?.results || [];
        }

        data = mapEmptyBatchToNoBatch(data);
        setStudentData(data);
      };

      fetchStudentData();
    }
  }, [selectedCourseId, selectedClassObj, studentTypeId, selectedSessionId]);

  const handleCourseSelection = (selectedCourseId) => {
    // Find the selected course object
    const selectedCourse = courses.find(
      (course) => course.course_id === selectedCourseId
    );

    // Set the selected course ID
    setSelectedCourseId(selectedCourse.course_id);

    // Set the selected course name
    setSelectedCourseName(selectedCourse.course_name);
  };

  const handleClassSelection = (selectedClassId) => {
    // Find the selected class object
    const selectedClassObj = selectedClass.find(
      (classObj) => classObj.class_id === selectedClassId
    );

    // Set the selected class object
    setSelectedClassObj(selectedClassObj);

    // Set the selected class name
    setSelectedClassName(selectedClassObj.class_name);
  };
  const unassignStudents = () => {
    const selectedStudentsCopy = secondTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setFirstTableData((prevFirstTableData) => [
      ...prevFirstTableData,
      ...selectedStudentsCopy,
    ]);
    const newSecondTableData = secondTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the secondTableData state with the new array
    setSecondTableData(newSecondTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  // useEffect(() => {
  //   const newBatchCode = `${selectedCourseName}-${selectedClassName}-${classTypeAbbreviations[coachingMode]}-${batchName}`;
  //   setBatchCode(newBatchCode);
  // }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

  useEffect(() => {
    const parts = [
      selectedCourseName,
      selectedClassName,
      classTypeAbbreviations[coachingMode],
      batchName,
    ].filter(Boolean); // removes undefined, null, empty string

    setBatchCode(parts.join("-"));
  }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

  const createBatch = async () => {
    if (
      !batchName ||
      !studentTypeId ||
      !coachingMode ||
      !selectedCourseId ||
      !selectedClassObj ||
      !selectedSessionId
    ) {
      setIsMessageBoxVisible(true);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please fill all the required fields.</span>
            </div>
          </div>
        );
        if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
      }
      return;
    }

    const url = `${FULL_API_BASE_URL}/new-batch?client_id=${clientId}&client_br_id=${clientBranchId}&batch_name=${batchName}&batch_code=${selectedCourseName}-${selectedClassName}-${
      classTypeAbbreviations[coachingMode]
    }-${batchName}&batch_desc=${batchDescription}&coaching_mode_id=${
      classTypeToId[coachingMode]
    }&tentative_exam_dt=${format(
      tentativeExamDate,
      "yyyy-MM-dd"
    )} 13:09:58.000&course_id=${selectedCourseId}&class_id=${
      selectedClassObj.class_id
    }&user_name=${user_name}&session_id=${selectedSessionId}`;

    // Format the students data
    const studentsFormatted = secondTableData.map((student) => ({
      student_id: student.student_id,
    }));
    const hasAssignedStudents = secondTableData.some(
      (student) => student.batch_name !== null
    );

    const postBatch = async () => {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(studentsFormatted), // Send the formatted students data in the body
        });
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Batch Created Successfully.</span>
              </div>
            </div>
          );
          setActiveImg(SuccessImg);
        }
        setTimeout(() => {
          navigate("/batch_dashboard");
        }, 2000);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
      } catch (error) {
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  Error in submitting the form. Please fill all the input
                  fields.
                </span>
              </div>
            </div>
          );
          setActiveImg(ErrorImg);
        }
      }
    };

    if (hasAssignedStudents) {
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                There are students who are batch assigned. Are you sure you want
                to proceed?
              </span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                  postBatch();
                }}
              >
                YES
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => setIsMessageBoxVisible(false)}
              >
                NO
              </button>
            </div>
          </div>
        );
        if (setActiveImg && InterogativeImg) setActiveImg(InterogativeImg);
        setIsMessageBoxVisible(true);
      }
    } else {
      postBatch();
    }
  };

  const handleStudentTypeSelection = (e) => {
    const selectedStudentTypeName = e.target.value;
    setStudentTypeId(classTypeToId[selectedStudentTypeName]);
  };

  // useEffect(() => {
  //   if (selectedCourseId && selectedClassObj && studentTypeId) {
  //     const fetchStudentData = async () => {
  //       const response = await fetch(
  //         `${FULL_API_BASE_URL}/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
  //       );
  //       let data = await response.json();

  //       data = mapEmptyBatchToNoBatch(data);

  //       setStudentData(data); // Save the student data in the state
  //     };

  //     fetchStudentData();
  //   }
  // }, [selectedCourseId, selectedClassObj, studentTypeId]);

  const assignStudents = () => {
    const selectedStudentsCopy = firstTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setSecondTableData((prevSecondTableData) => [
      ...prevSecondTableData,
      ...selectedStudentsCopy,
    ]);
    const newFirstTableData = firstTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the firstTableData state with the new array
    setFirstTableData(newFirstTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  // In your render method, when a checkbox is clicked
  const handleCheckboxClick = (studentId) => {
    setSelectedStudentIds((prevSelectedStudentIds) => {
      if (prevSelectedStudentIds.includes(studentId)) {
        // If the student is already selected, unselect them
        return prevSelectedStudentIds.filter((id) => id !== studentId);
      } else {
        // If the student is not selected, select them
        return [...prevSelectedStudentIds, studentId];
      }
    });
  };

  // const mapEmptyBatchToNoBatch = (studentData) => {
  //   return studentData.map((student) => ({
  //     ...student,
  //     batch_name: student.batch_name === "" ? "NoBatch" : student.batch_name,
  //   }));
  // };

  const mapEmptyBatchToNoBatch = (studentData) => {
    // Ensure studentData is an array
    const dataArray = Array.isArray(studentData)
      ? studentData
      : studentData?.data || studentData?.students || [];

    return dataArray.map((student) => ({
      ...student,
      batch_name:
        student.batch_name === "" ? "Not Assigned" : student.batch_name,
    }));
  };

  useEffect(() => {
    // Clear the table first
    setFirstTableData([]);

    // Use setTimeout to allow for the table to clear before setting the new data
    setTimeout(() => {
      // If excludeAssigned is true, only include students where batch_name is null
      if (excludeAssigned) {
        setFirstTableData(
          studentData.filter((student) => student.batch_name === null)
        );
      } else {
        setFirstTableData(studentData);
      }
    }, 0); // setTimeout with 0 delay ensures the clear operation happens first
  }, [excludeAssigned, studentData]);

  // const fetchSessionsData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/get-sessions-list`,
  //       {
  //         method: "GET",
  //         headers: {
  //           accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const result = await response.json();

  //     if (result.status === 200 && result.data) {
  //       const formattedSessions = result.data.map((session) => ({
  //         id: session.session_id,
  //         label: session.session_name,
  //       }));
  //       setSessionData(formattedSessions);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching sessions data:", error);
  //   }
  // };

  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedSessions = result.data.map((session) => ({
          id: session.session_id,
          label: session.session_name,
        }));
        setSessionData(formattedSessions);

        // ✅ Auto-select the latest session (highest session_id)
        const latestSession = result.data.reduce((prev, current) =>
          prev.session_id > current.session_id ? prev : current
        );
        setSelectedSessionId(latestSession.session_id);
      }
    } catch (error) {
      console.error("Error fetching sessions data:", error);
    }
  };

  useEffect(() => {
    fetchSessionsData();
  }, []);

  return (
    <div className="create-role-container">
      <div
        className="create-role-container-tagging"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="create-role-heading">Create Batch</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => {
              navigate(`/batch_dashboard`);
            }}
          >
            CANCEL
          </button>
          <button className="cr-cancel-btn" onClick={createBatch}>
            SAVE
          </button>
        </div>
      </div>
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>BATCH DETAILS</h2>
          </div>
          <div className="accordion-btn" onClick={toggleBasicInfoAccordion}>
            {isOpenBasicInfo ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenBasicInfo && (
          <div className="accordion-content-tagging-container">
            <div className="grid-container-tagging">
              <div className="grid-item">
                <FormInputs
                  label="Batch Name"
                  value={batchName}
                  onChange={(e) => setBatchName(e.target.value)}
                  required
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Description"
                  value={batchDescription}
                  onChange={(e) => setBatchDescription(e.target.value)}
                  required
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Batch Code"
                  value={batchCode}
                  disabled
                  required
                />
              </div>
              <div className="grid-item">
                <SelectedValue
                  label="Session"
                  style={{ width: "100%" }}
                  selected={selectedSessionId}
                  setSelected={setSelectedSessionId}
                  options={sessionData}
                  isRequired={true}
                />
              </div>
              <div className="grid-item">
                <DropDownCB
                  label="Course"
                  selected={selectedCourseId}
                  style={{ width: "100%" }}
                  setSelected={handleCourseSelection}
                  options={courses.map((course) => ({
                    id: course.course_id,
                    label: course.course_name,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="grid-item">
                <DropDownCB
                  label="Class"
                  style={{ width: "100%" }}
                  selected={selectedClassObj ? selectedClassObj.class_id : ""}
                  setSelected={handleClassSelection}
                  options={selectedClass.map((classObj) => ({
                    id: classObj.class_id,
                    label: classObj.class_name,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="grid-item">
                <DropDownCB
                  label="Batch Coaching Mode"
                  selected={coachingMode}
                  style={{ width: "100%" }}
                  setSelected={setCoachingMode}
                  options={coachingModeOptions}
                  isRequired={true}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Tentative Exam Date"
                  type="month"
                  value={tentativeExamDate}
                  onChange={(e) => setTentativeExamDate(e.target.value)}
                  required
                  min={new Date().toISOString().slice(0, 7)}
                />
              </div>
              <div className="grid-item">
                <SelectedValue
                  label="Mentor"
                  style={{ width: "100%" }}
                  selected={selectedMentor}
                  setSelected={setSelectedMentor}
                  options={[{ id: "N/A", label: "N/A" }]}
                  isRequired={true}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>ASSIGN STUDENT(S)</h2>
          </div>
          <div className="accordion-btn" onClick={toggleAssignStudentAccordion}>
            {isOpenAssignStudent ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenAssignStudent && (
          <div className="accordion-content-tagging-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "30px",
                padding: "20px",
              }}
            >
              <div style={{ display: "flex", gap: "40px" }}>
                {[
                  { id: 1, label: "Online" },
                  { id: 2, label: "Classroom" },
                  { id: 3, label: "Both" },
                ].map((type) => (
                  <label
                    key={type.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      color: "#6A6A6A",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      value={type.id}
                      checked={studentTypeId === type.id}
                      onChange={() => setStudentTypeId(type.id)}
                    />
                    <div style={{ marginLeft: "8px", fontSize: "14px" }}>
                      {type.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
            {/* </div>
            </div> */}
            <hr className="dotted-hr ms-cs2 mb-cs2" />
            <div className="row-cs" style={{ marginLeft: "0px" }}>
              <div className="col-cs grey-color-font">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="form-check transparent-margin-all">
                    <input
                      className="form-check-input ms-cs3"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                      checked={excludeAssigned}
                      onChange={() => setExcludeAssigned(!excludeAssigned)}
                    />
                    <label
                      className="form-check-label mb-cs2 ms-cs2"
                      htmlFor="flexCheckChecked"
                    >
                      Exclude students with assigned batch
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div className="rounded-rectangle-CBV2" />
                      <span
                        className="grey-color-font"
                        style={{ fontSize: "14px" }}
                      >
                        Online
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div className="rounded-rectangle-2-CBV2" />
                      <span
                        className="grey-color-font"
                        style={{ fontSize: "14px" }}
                      >
                        Classroom
                      </span>
                    </div>
                  </div>
                </div>
                <div className="div-contains-search-cvb">
                  <input
                    className="input-search-cvb"
                    type="text"
                    onChange={(e) =>
                      setFirstSearchTerm(e.target.value.toLowerCase())
                    }
                  />
                  <button
                    style={{
                      width: "5%",
                      backgroundColor: "white",
                      border: "none",
                    }}
                  >
                    <img src={YellowSearch} className="search-cvb" alt="" />
                  </button>
                </div>
                {/* <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
                  <table className="table-CBV2-1" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}> */}
                <div className="cr-bt-table-scroll-container">
                  <table
                    className="table-CBV2-1"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                      border: "none",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: "0",
                        zIndex: "1",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <tr style={{ border: "1px solid #999", height: "30px" }}>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "30%",
                            color: "#6A6A6A",
                          }}
                        >
                          Name
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Roll. No.
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Batch
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "10%",
                            color: "#6A6A6A",
                          }}
                        >
                          Type
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Mentor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstTableData
                        .filter(
                          (student) =>
                            (!excludeAssigned || student.batch_name !== "") &&
                            student.full_name
                              .toLowerCase()
                              .includes(firstSearchTerm)
                        )
                        .slice(
                          (currentPage - 1) * itemsPerPage,
                          currentPage * itemsPerPage
                        )
                        .map((student) => (
                          <tr
                            style={{ border: "1px solid #999" }}
                            key={student.student_id}
                          >
                            <td
                              style={{
                                width: "30%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              <input
                                type="checkbox"
                                style={{ margin: "5px" }}
                                checked={selectedStudentIds.includes(
                                  student.student_id
                                )}
                                onChange={() =>
                                  handleCheckboxClick(student.student_id)
                                }
                              />
                              <span title={student.full_name}>
                                {student.full_name}
                              </span>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              {student.roll_number}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              {student.batch_name
                                ? student.batch_name
                                : "Not Assigned"}
                            </td>
                            <td style={{ width: "10%", color: "#6A6A6A" }}>
                              <div className="center-items-cbv2">
                                <div
                                  className={
                                    student.class_type_id === 1
                                      ? "rounded-rectangle-CBV2"
                                      : student.class_type_id === 2
                                      ? "rounded-rectangle-2-CBV2"
                                      : ""
                                  }
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              <span title={student.mentor_name}>
                                {student.mentor_name}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="row-cs mt-cs3">
                  <div className="col-cs">
                    {firstTableData.length > 0 && (
                      <>
                        <p className="mt-cs1 ms-cs3 grey-color-font">
                          {selectedStudentIds.length} of {itemsPerPage}{" "}
                          selected.
                        </p>
                        <p className="mt-cs2 mb-cs2 ms-cs3 grey-color-font">
                          Change table size :
                          {[25, 50, 100].map((size) => (
                            <button
                              key={size}
                              className={`table-size-change-buttons ${
                                selectedButton === size ? "selected" : ""
                              }`}
                              onClick={() => {
                                setItemsPerPage(size);
                                setSelectedButton(size);
                              }}
                            >
                              {size}
                            </button>
                          ))}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="col-cs">
                    <div className="pagination-cs">
                      <a
                        href="#"
                        className="leftarrow-rounded"
                        onClick={() => setCurrentPage(1)}
                      >
                        <img
                          className="leftarrow-pagination"
                          src={leftarrow}
                          alt=""
                        />
                      </a>
                      <a
                        href="#"
                        onClick={() =>
                          setCurrentPage(Math.max(1, currentPage - 1))
                        }
                      >
                        {"<"}
                      </a>
                      {Array(Math.ceil(studentData.length / itemsPerPage))
                        .fill()
                        .map((_, index) => (
                          <a
                            href="#"
                            className={
                              index + 1 === currentPage ? "active" : ""
                            }
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </a>
                        ))}
                      <a
                        href="#"
                        onClick={() =>
                          setCurrentPage(
                            Math.min(
                              Math.ceil(studentData.length / itemsPerPage),
                              currentPage + 1
                            )
                          )
                        }
                      >
                        {">"}
                      </a>
                      <a
                        href="#"
                        className="rightarrow-rounded"
                        onClick={() =>
                          setCurrentPage(
                            Math.ceil(studentData.length / itemsPerPage)
                          )
                        }
                      >
                        <img
                          className="rightarrow-pagination"
                          src={rightarrow}
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-cs1">
                <button
                  type="button"
                  className="arrow-button-cs"
                  onClick={assignStudents}
                >
                  <p>
                    <i className="arrow right"></i>
                    <i className="arrow right margin-arrow-cs"></i>
                  </p>
                </button>
                <button
                  type="button"
                  className="arrow-button-cs mt-cs4"
                  onClick={unassignStudents}
                >
                  <p>
                    <i className="arrow left margin-arrow-cs-2"></i>
                    <i className="arrow left"></i>
                  </p>
                </button>
              </div>
              <div className="col-cs" style={{ marginRight: "10px" }}>
                <div className="form-check transparent-margin-all grey-color-font">
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked"
                  >
                    Student Count : {secondTableData.length}
                  </label>
                </div>
                <div className="div-contains-search-cvb-second">
                  <input
                    className="input-search-cvb"
                    type="text"
                    onChange={(e) =>
                      setSecondSearchTerm(e.target.value.toLowerCase())
                    }
                  />
                  <button
                    style={{
                      width: "5%",
                      backgroundColor: "white",
                      border: "none",
                    }}
                  >
                    <img src={YellowSearch} className="search-cvb" alt="" />
                  </button>
                </div>
                <div className="cr-bt-table-scroll-container">
                  <table
                    className="table-CBV2-1"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                      border: "none",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: "0",
                        zIndex: "1",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <tr style={{ border: "1px solid #999", height: "30px" }}>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "30%",
                            color: "#6A6A6A",
                          }}
                        >
                          Name
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Roll No.
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Batch
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "10%",
                            color: "#6A6A6A",
                          }}
                        >
                          Type
                        </th>
                        <th
                          style={{
                            border: "none",
                            fontSize: "14px",
                            width: "20%",
                            color: "#6A6A6A",
                          }}
                        >
                          Mentor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {secondTableData
                        .filter((student) =>
                          student.full_name
                            .toLowerCase()
                            .includes(secondSearchTerm)
                        )
                        .map((student) => (
                          <tr
                            style={{ border: "1px solid #999" }}
                            key={student.student_id}
                          >
                            <td
                              style={{
                                width: "30%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              <input
                                type="checkbox"
                                style={{ margin: "5px" }}
                                checked={selectedStudentIds.includes(
                                  student.student_id
                                )}
                                onChange={() =>
                                  handleCheckboxClick(student.student_id)
                                }
                              />
                              <span title={student.full_name}>
                                {student.full_name}
                              </span>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              {student.roll_number}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              {student.batch_name
                                ? student.batch_name
                                : "Not Assigned"}
                            </td>
                            <td style={{ width: "10%", color: "#6A6A6A" }}>
                              <div className="center-items-cbv2">
                                <div
                                  className={
                                    student.class_type_id === 1
                                      ? "rounded-rectangle-CBV2"
                                      : student.class_type_id === 2
                                      ? "rounded-rectangle-2-CBV2"
                                      : ""
                                  }
                                />
                              </div>
                            </td>
                            <td
                              style={{
                                width: "20%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#6A6A6A",
                              }}
                            >
                              <span title={student.mentor_name}>
                                {student.mentor_name}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div className="row-cs mt-cs3">
                  <div className="col-cs">
                    <p className="mt-cs1 ms-cs3 grey-color-font">
                      {selectedStudentIds.length} of {secondTableData.length}{" "}
                      selected.
                    </p>
                  </div>
                  <div className="col-cs">
                    <div className="pagination-cs-2">
                      <a
                        href="#"
                        className="leftarrow-rounded"
                        onClick={() => setCurrentPage(1)}
                      >
                        <img
                          className="leftarrow-pagination"
                          src={leftarrow}
                          alt=""
                        />
                      </a>
                      <a
                        href="#"
                        onClick={() =>
                          setCurrentPage(Math.max(1, currentPage - 1))
                        }
                      >
                        {"<"}
                      </a>
                      {Array(Math.ceil(secondTableData.length / itemsPerPage))
                        .fill()
                        .map((_, index) => (
                          <a
                            href="#"
                            className={
                              index + 1 === currentPage ? "active" : ""
                            }
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </a>
                        ))}
                      <a
                        href="#"
                        onClick={() =>
                          setCurrentPage(
                            Math.min(
                              Math.ceil(secondTableData.length / itemsPerPage),
                              currentPage + 1
                            )
                          )
                        }
                      >
                        {">"}
                      </a>
                      <a
                        href="#"
                        className="rightarrow-rounded"
                        onClick={() =>
                          setCurrentPage(
                            Math.ceil(secondTableData.length / itemsPerPage)
                          )
                        }
                      >
                        <img
                          className="rightarrow-pagination"
                          src={rightarrow}
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateBatch;
